import * as React from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
function SvgIconCustomFlash({
  title,
  titleId,
  ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path d="M11.5.5L4 11h4.5L7 19.5 15 8h-4.5L13 .5z" />
    </svg>
  );
}
export default SvgIconCustomFlash;
